var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notData"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/img/cat-in-space@1x.png")}}),_c('div',{staticClass:"mes-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }